import { render, staticRenderFns } from "./ControllerSimple.vue?vue&type=template&id=6837c870&lang=pug&"
import script from "./ControllerSimple.vue?vue&type=script&lang=js&"
export * from "./ControllerSimple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports